import React, { useState } from 'react'
import { TimingPositionsDTO } from '../../../interfaces/TimingPositionsDTO';
import styles from './bladeopener.module.css'
import { ViewType } from '../../../interfaces/internal/ViewProps';
interface Props {
  intermediatepoint: TimingPositionsDTO | null;
  isactive: number | null;
  changedState: () => void;
  vtype: ViewType | null;
}
const BladeOpenerButton = ({ intermediatepoint, isactive, changedState,vtype }: Props) => {

  return (
    <button type="button" onClick={changedState} className={"btn btn-secondary  " + (styles.class_button) + " " + (isactive ? styles.active : "") + " " + (intermediatepoint && (intermediatepoint.IsTvPos ? styles.tv_pos : " "))}>{intermediatepoint ? intermediatepoint.Name :"Startlist"}</button>
  )
}

export default BladeOpenerButton